import { HotelNavigationUtility as CoreHotelNavigationUtility } from "@b2bportal/core-utilities";

/*
 * It turned out that the core HotelNavigationUtility doesn't handle non-latin well,
 * Override it to support Korean characters.
 */

const placeLabelToUrl = (label?: string) => {
  return label ?? "";
};

const placeLabelAndSublabelToUrl = (label?: string, subLabel?: string) => {
  if ((subLabel?.length ?? 0) > 0) {
    return `${label ?? ""}_${subLabel}`;
  }
  return label ?? "";
};

const urlToPlaceQuery = (url?: string) => {
  return url?.replace(/_/g, " ") ?? "";
};

export const HotelNavigationUtility = {
  ...CoreHotelNavigationUtility,
  placeLabelToUrl,
  placeLabelAndSublabelToUrl,
  urlToPlaceQuery,
};
